var map = {
	"./Nyarlathotep.jpg": 141,
	"./d20-clipart-crit-3-original.png": 142,
	"./default.jpg": 65,
	"./dice.jpg": 71,
	"./fumble.png": 72,
	"./loup-garou-les-dechus.jpg": 143,
	"./medieval.jpg": 70,
	"./mektonz.jpg": 144,
	"./swd6.jpg": 145,
	"./testFantasy.jpg": 69,
	"./testHorror.jpg": 68,
	"./testsf.jpg": 67,
	"./warhammer2.jpg": 146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;